import { useCallback, useState } from "react";
import { getDefaultMonthRange, toDateRangeValue, buildSubscriptionFilterPayload } from "../utils";

export function useSubscriptionFilters(defaultFilters) {
  const [defaultRange] = useState(getDefaultMonthRange);
  const [filters, setFilters] = useState(defaultFilters);
  const [appliedFilters, setAppliedFilters] = useState(() =>
    buildSubscriptionFilterPayload(defaultFilters)
  );
  const [dateValue, setDateValue] = useState(defaultRange);
  const [isExporting, setIsExporting] = useState(false);

  const handleApply = useCallback(() => {
    setAppliedFilters(buildSubscriptionFilterPayload(filters));
  }, [filters]);

  const handleReset = useCallback(() => {
    setFilters(defaultFilters);
    setAppliedFilters(buildSubscriptionFilterPayload(defaultFilters));
    setDateValue(defaultRange);
  }, [defaultFilters, defaultRange]);

  const handleDateSelect = useCallback((date) => {
    setDateValue(toDateRangeValue(date));
  }, []);

  return {
    filters,
    setFilters,
    appliedFilters,
    dateValue,
    isExporting,
    setIsExporting,
    handleApply,
    handleReset,
    handleDateSelect,
  };
}
